import {selector} from './selector';
import * as events from "./events";

const PageRegisterTagFormOBO = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function initEvents() {
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
        $(document).on('input', selector.email, events.toggleEmailVerificationUI);
        $(document).on('click', selector.emailSendCodeBtn, events.sendVerificationCode);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);

        events.toggleEmailVerificationUI();

        $(document).on('submit', selector.form.main, function (e) {
            const $submitBtn = $(selector.btn.submit);
            $submitBtn.prop('disabled', true);
            $submitBtn.addClass('disabled');
        });
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTagFormOBO};